// Library
import React from 'react';

// Components
import DatosDeMiEvento from './page/EventData/DatosDeMiEvento';
// import MisMonederos from './page/EventData/MisMonederos';
import GiftOpening from './page/EventData/GiftOpening';
import CelebratedCard from './page/EventData/CelebratedCard';
import ContractPage from './page/EventData/ContractPage';
import ClosureGift from './page/EventData/ClosureGift';
import DeliveryAddress from './page/EventData/DeliveryAddress';
import EventManagementIndex from './page/EventData/EventManagementIndex';

export const CLOSING_GIFT = 'RegaloPorCierre';
export const OPENING_GIFT = 'RegaloDeApertura';

export const eventManagmentConfig = {
  eventData: {
    DatosDeMiEvento: { component: React.createFactory(DatosDeMiEvento), displayName: 'Datos de mi evento' },
    DirecciónDeEntrega: { component: React.createFactory(DeliveryAddress), displayName: 'Direcciones de entrega' },
    RegaloDeApertura: { component: React.createFactory(GiftOpening), displayName: 'Regalo por apertura' },
    RegaloPorCierre: { component: React.createFactory(ClosureGift), displayName: 'Regalo por cierre' },
    TarjetaDeFestejado: { component: React.createFactory(CelebratedCard), displayName: 'Tarjeta de Festejado' },
    Contrato: { component: React.createFactory(ContractPage), displayName: 'Contrato' },
    // MisMonederos: { component: React.createFactory(MisMonederos), displayName: 'Mis monederos' },
  },
};

export const eventManagmentConfigWAP = {
  eventData: {
    EventManagementIndex: { component: React.createFactory(EventManagementIndex), displayName: 'EventManagementIndex' },
    DatosDeMiEvento: { component: React.createFactory(DatosDeMiEvento), displayName: 'Datos de mi evento' },
    DirecciónDeEntrega: { component: React.createFactory(DeliveryAddress), displayName: 'Direcciones de entrega' },
    RegaloDeApertura: { component: React.createFactory(GiftOpening), displayName: 'Regalo por apertura' },
    RegaloPorCierre: { component: React.createFactory(ClosureGift), displayName: 'Regalo por cierre' },
    TarjetaDeFestejado: { component: React.createFactory(CelebratedCard), displayName: 'Tarjeta de Festejado' },
    Contrato: { component: React.createFactory(ContractPage), displayName: 'Contrato' },
    // MisMonederos: { component: React.createFactory(MisMonederos), displayName: 'Mis monederos' },
  },
};
